import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CertificationAdminSession } from 'types/CertificationAdmin';
import { SKIP_AUTO_DISCONNECT } from '../../interceptors/auto-disconnect/auto-disconnect.interceptor';

@Injectable()
export class CertificationAdminApiService {
  public constructor(private readonly httpClient: HttpClient) {}

  public createSession(apiUrl: string): Observable<CertificationAdminSession> {
    return this.httpClient.post<CertificationAdminSession>(
      `${apiUrl.replace(/\/+$/, '')}/v2/api/auth/admin/session`,
      {},
      // A 401 from the certification API must not log the user out of the dashboard
      { withCredentials: true, context: new HttpContext().set(SKIP_AUTO_DISCONNECT, true) },
    );
  }
}
